<template>
  <b-card>
    <div class="flex justify-between">
      <div class="top-txt">
        <h4><b>Company Dashboard</b></h4>
        <span>Available Licenses : {{ licence }} </span>
      </div>
      <base-button
        outline
        type="primary"
        @click="handleGenerateModal"
        class="flex px-6 py-1 mx-1"
        >+ Generate IDs
      </base-button>
    </div>
    <b-modal
      class="relative text-white"
      header-bg-variant="primary"
      header-text-variant="white"
      v-model="generateIdModal"
      size="sm"
      centered
      hide-footer
    >
      <h2 class="text-white absolute custop28px">Generate IDs</h2>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div class="flex justify-center pt-5">
            <div class="w-48">
              <p class="input-title textcolor">Enter No. of IDs</p>
              <base-input
                v-model="IDs"
                name="No. of IDs"
                :rules="{ required: true, numeric: true }"
                placeholder="Enter No. of IDs"
              >
              </base-input>
            </div>
          </div>

          <div class="flex justify-center footer-btn">
            <b-button class="btn-submit" @click="onSubmit"
              >Generate IDs</b-button
            >
            <b-button class="btn-clr" @click="handleGenerateModal"
              >Cancel</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-input-group class="my-6">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      ref="multipleTable"
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color"
      :data="displayedPages"
      border
    >
      <!-- <el-table-column type="selection" width="55" v-model="selecteddata">
      </el-table-column> -->

      <el-table-column
        label="Sr No."
        prop="srno"
        type="index"
        min-width="140px"
      >
      </el-table-column>
      <el-table-column label="Employee ID" min-width="250px" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            {{ row.eid }}
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Created Date" prop="date" min-width="140px">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="130px" prop="statusaction">
        <template v-slot="{ row }">
          <base-button
            :class="`bg-${row.actioncolor}`"
            class="border-none cust-btn-xs"
            size="sm"
            >{{ row.isActive ? "Active" : "InActive" }}</base-button
          >
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Edited By"
        prop="editedby"
        min-width="130px"
        
      >
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
        </template>
      </el-table-column> -->

      <el-table-column label="Share Details" prop="editedby" min-width="130px">
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="190px">
        <template slot-scope="scope">
          <div class="flex items-center">
            <div class="flex items-center mr-4 cursor-pointer">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-6 text-blue-500 cursor-pointer"
                class="mr-2"
                @click="handleEdit(scope)"
              ></feather-icon>
            </div>
            <div class="flex items-center cursor-pointer">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-6 text-red-600 cursor-pointer"
                class="ml-2"
                @click="handleDelete(scope)"
              ></feather-icon>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "@/assets/scss/Index.scss";
import CompanyData from "./CompanyData";
// import EditDetail from "./components/EditDetail.vue";
// import AddBannerSidebar from "./components/AddBannerSidebar.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    // EditDetail,
    // AddBannerSidebar
  },
  data() {
    return {
      CompanyData,
      editModal: false,
      openAddBannerSidebar: false,
      selecteddata: [],

      generateIdModal: false,
      IDs: "",

      perPage: 10,
      totalRows: 0,
      tableData: [],
      search: "",
      currentPage: 1,
      licence: 0,
    };
  },
  watch: {
    async currentPage() {
      await this.getAll();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAll();
        this.currentPage = 1;
      }, 500),
    },
  },
  methods: {
    handleGenerateModal() {
      this.generateIdModal = !this.generateIdModal;
    },
    async function() {
      await this.$store.dispatch("corporate/get_all");
      this.get_AllBooking.result.forEach((ele) => {
        if (ele.userId === this.userData._id) {
          this.licence = ele.availableLicence;
        }
      });

      // console.log(this.selecteddata);
      let payload = "testing";
      await this.$store.dispatch("companydash/get_all", payload);

      // console.log(this.get_company_detail);
    },

    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = {
        _id: row._id,
        userId: row.userId,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("companydash/delete", payload);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handleEdit(scope) {
      let { row } = scope;

      await this.$store.commit("companydash/EDIT_DASH_DETAILS", row);
      this.$router.push({ name: "editdash" });
    },
    async onSubmit() {
      try {
        let payload = {
          generate: this.IDs,
        };
        let payload2 = {
          licence: this.IDs,
        };
        await this.$store.dispatch("companydash/generateEmployee", payload);

        this.handleGenerateModal();
        this.function();
        this.IDs = "";
      } catch (error) {
        if (error.response.status == 500) {
          this.$swal.fire({
            title: "Licence limit exceeds",
            text: "Please check available licence",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        console.log(error);
      }
    },
  },

  computed: {
    ...mapState("companydash", {
      get_company_detail: "get_company_detail",
    }),
    ...mapState("auth", ["userData"]),
    ...mapState("corporate", ["get_AllBooking"]),

    displayedPages() {
      return this.get_company_detail.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  mounted() {
    this.function();
  },
};
</script>

<style>
.textcolor {
  color: #777777 !important;
}
.custop28px {
  top: -28px;
}
</style>
